// The prograde HUD's own construction: the velocity, target, assist-aim and
// burn markers hung off the flight state and the pilot's guidance.
import * as THREE from 'three';
import { createProgradeHud, type ProgradeGuidance, type ProgradeHudHandle } from '../scene/progradeHud';
import type { DvCorrection } from '../sim/dvCorrection';
import type { FlightState } from '../sim/flight';

export interface ProgradeViewDeps {
  camera: THREE.PerspectiveCamera;
  scene: THREE.Scene;
  bubble: THREE.Group;
  invBubble: THREE.Quaternion;
  flight: FlightState;
  guidanceToTarget(): ProgradeGuidance | null;
  assistLive(): boolean;
  targetNamed(): boolean;
  /** `game.engagement`: built after this view, in `main.ts` still. */
  readonly engagement: object | null;
  /** Built off `cruiseDrive`, after this view, in `main.ts` still. */
  readonly dvCorrection: DvCorrection;
}

export function createProgradeView(deps: ProgradeViewDeps): ProgradeHudHandle {
  return createProgradeHud({
    camera: deps.camera,
    scene: deps.scene,
    bubble: deps.bubble,
    _invBubble: deps.invBubble,
    flight: deps.flight,
    guidanceToTarget: deps.guidanceToTarget,
    assistLive: deps.assistLive,
    targetNamed: deps.targetNamed,
    get engagement() { return deps.engagement; },
    get dvCorrection() { return deps.dvCorrection; },
  });
}
